import { FC, useMemo } from 'react'
import Star from '../../../assets/icons/star-filled.svg'
import HalfStar from '../../../assets/icons/star-half-filled.svg'
import EmptyStar from '../../../assets/icons/star-outline.svg'
import { Container, FullStarIcon, HalfStarIcon, EmptyStarIcon } from './styles'

interface Props {
    averageRating: number
    maxStars?: number
}

const StarsContainer: FC<Props> = ({ averageRating, maxStars = 5 }) => {
    const ratingStars = useMemo(() => {
        const ratingValue = Number.isNaN(averageRating) ? 0 : averageRating

        // round to nearest 0.5
        const roundedRating = Math.round(ratingValue * 2) / 2

        const fullStars = Math.floor(roundedRating)
        const hasHalfStar = roundedRating % 1 === 0.5
        const emptyStars = maxStars - fullStars - (hasHalfStar ? 1 : 0)

        return {
            fullStars,
            hasHalfStar,
            emptyStars: Math.max(0, emptyStars),
        }
    }, [averageRating, maxStars])

    return (
        <Container>
            {Array.from({ length: ratingStars.fullStars }).map((_, index) => (
                <FullStarIcon key={`full-${index}`} as={Star} />
            ))}
            {ratingStars.hasHalfStar && <HalfStarIcon key="half" as={HalfStar} />}
            {Array.from({ length: ratingStars.emptyStars }).map((_, index) => (
                <EmptyStarIcon key={`empty-${index}`} as={EmptyStar} />
            ))}
        </Container>
    )
}

export default StarsContainer
